export const BREAKPOINTS = {
  SM: 654,
  LG: 980,
  XL: 1296,
  XXL: 1602,
}
